export const getMeetingObjectFromPayload = (payload) => {
  if (!payload) {
    return null;
  }

  if (payload.meetingInstances?.length) {
    return payload;
  }

  if (payload.meeting?.meetingInstances?.length) {
    return payload.meeting;
  }

  return null;
};

export const getMeetingAgendaFromPayload = (payload) =>
  getMeetingObjectFromPayload(payload)?.meetingInstances?.[0]?.agenda || null;

export const getMeetingLiveActivityFromPayload = (payload) =>
  getMeetingAgendaFromPayload(payload)?.liveActivity || {};

export const getMeetingLiveToolsFromPayload = (payload) =>
  getMeetingAgendaFromPayload(payload)?.liveTools || [];
